/* global __CLIENT__, API_ROOT, API_SEARCH */

import cookie from 'react-cookie';

import authService from './auth';
import { fetchJSON, postJSON } from './helpers';

import { stringifyQS } from '../../utils';

// Define API config
export const API = {};

// Configuration for Event Search API
API.EVENT_SEARCH = {
  URL: `${API_ROOT}/v1.0/event-search`,
};

API.SEARCH = {
  URL: API_SEARCH,
};

// Configuration for Events API
API.EVENTS = {
  URL: `${API_ROOT}/v1.5/events`,
};

// Configuration for Races API
API.RACES = {
  URL: `${API_ROOT}/v1.0/races`,
};

// Configuration for Reference Data API
API.REFERENCE_DATA = {
  URL: `${API_ROOT}/v1.0/reference-data`,
};

// Configuration for Reviews API
API.REVIEWS = {
  URL: `${API_ROOT}/v1.0/reviews`,
};

API.ORGANISERS = {
  URL: `${API_ROOT}/v1.1/organisers`,
};

API.TICKETS = {
  URL: `${API_ROOT}/v1.0/tickets`,
};

const apiService = {};

// Headers used in every request
apiService.getHeaders = endpointHeaders => ({
  // Auth0 token
  Authorization: `Bearer ${authService.getAuthCookie()}`,
  // Describe origin of request
  'Client-Origin': `web-${__CLIENT__ ? 'client' : 'server'}`,
  // Google Analytics Client ID
  'Session-ID': cookie.load('_ga'),
  // Auth0 user ID
  'User-ID': authService.getUserCookie(),
  // Apply endpoint specific headers
  ...endpointHeaders,
});

apiService.createReview = payload =>
  postJSON(API.REVIEWS.URL, apiService.getHeaders(), payload, true);

apiService.fetchOrganiser = id =>
  fetchJSON(`${API.ORGANISERS.URL}/${id}`, apiService.getHeaders());

apiService.fetchTicket = id =>
  fetchJSON(`${API.TICKETS.URL}/${id}`, apiService.getHeaders());

apiService.fetchOrganiserEvents = (id, query) => {
  let requestURI = `${API.ORGANISERS.URL}/${id}`;
  if (query) {
    const queryString = stringifyQS(query);
    requestURI += `?${queryString}`;
  }
  return fetchJSON(requestURI, apiService.getHeaders());
};

apiService.fetchEvent = id =>
  fetchJSON(`${API.EVENTS.URL}/${id}`, apiService.getHeaders());

apiService.fetchEvents = (query) => {
  let requestURI = API.EVENT_SEARCH.URL;
  if (query) {
    const queryString = stringifyQS(query);
    requestURI += `?${queryString}`;
  }
  return fetchJSON(requestURI, apiService.getHeaders());
};

apiService.searchEvents = (query) => {
  let requestURI = API.SEARCH.URL;
  if (query) {
    const queryString = stringifyQS(query);
    requestURI += `?${queryString}`;
  }
  return fetchJSON(requestURI, apiService.getHeaders());
};

apiService.fetchReviews = (eventId, query) => {
  let requestURI = `${API.REVIEWS.URL}/${eventId}`;
  if (query) {
    requestURI += `?${stringifyQS(query)}`;
  }
  return fetchJSON(requestURI, apiService.getHeaders());
};

apiService.getSavedSearches = () =>
  fetchJSON(`${API.EVENT_SEARCH.URL}/saved`, apiService.getHeaders());

export default apiService;



// WEBPACK FOOTER //
// ./app/src/state/services/api.js